import { borderStyles, dividerStyles } from 'styles/theme';

import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled.div((_props) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
    gap: 28,
    borderWidth: '1px 1px 0px 1px',
    borderStyle: 'solid',
    borderColor: borderStyles.colors.primary,
    '&:first-of-type': {
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
    },
    '&:last-of-type': {
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      borderWidth: 1,
    },
    [mobileMediaQuery]: {
      flexDirection: 'column',
      padding: '24px 20px',
      gap: 20,
      borderRadius: 0,
      borderStyle: 'solid',
      borderColor: dividerStyles.colors.secondary,
      borderWidth: '4px 0px 0px',
      '&:first-of-type': {
        borderRadius: 0,
      },
      '&:last-of-type': {
        [mobileMediaQuery]: {
          borderRadius: 0,
          borderWidth: '4px 0px',
        },
      },
    },
  };
});
